import { render, staticRenderFns } from "./ResSync.vue?vue&type=template&id=18b727a2&"
import script from "./ResSync.vue?vue&type=script&lang=js&"
export * from "./ResSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports